import { GetFaxStatusResponse } from "../../data-model/faxStatusModel";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logDataToConsole } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

interface GetFaxStatusRequest {
  fax_details_id: string;
  form_id: string;
  org_id: string;
}

export const getFaxStatus = async (
  payload: GetFaxStatusRequest,
): Promise<GetFaxStatusResponse> => {
  try {
    const token = await getBearerToken();

    const response = await fetch(API_ENDPOINTS.GET_FAX_STATUS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `Request failed with status ${response.status}: ${errorData.message || response.statusText}`,
      );
    }

    const result = await response.json();
    return result;
  } catch (error) {
    logDataToConsole("error in getFaxStatus", error);
    throw error;
  }
};
